import {allowedPostage, PostageUsageType, useInfinitePostage} from "@twigsby/client-data";
import {ComboBoxControl, CountryFlag, SelectItemType, useTranslation} from "@twigsby/frontend-framework";
import {Controller} from "@twigsby/frontend-framework/lib/ReactHookForm";

type SendsPostageControlType = {
    countryCode: string;
    label: string;
    name: string;
    control: any;
    unregister: any;
    getValues: any;
    defaultValues?: any;
    reset?: boolean;
}

const SendsPostageControl = (props: SendsPostageControlType) => {
    const { t } = useTranslation();

    const { isLoading: postageLoading, data: postageData, error: postageError } = useInfinitePostage(props.countryCode, PostageUsageType.Sends);

    if(!props.countryCode) return null;

    const PostageOptions : Array<SelectItemType> = postageData ? postageData.pages.map((page) => page?.data && page.data.filter((postage, index: number) =>
        allowedPostage.includes(postage.value) ? { 'label': postage.label, 'value': postage.value } : null
    ))[0] : [];

    return (
        <div className={'form-group'}>
            <label className={'flex-row postage-label'}>
                <CountryFlag
                    countryCode={props.countryCode}
                />
                {`${props.countryCode} Postage`}
            </label>

            <Controller
                control={props.control}
                name={props.name}
                rules={{
                    required: t('validation.required')
                }}
                defaultValue={props.defaultValues}
                render={({field}) =>
                    <ComboBoxControl
                        name={props.name}
                        placeholder={`Select Postage...`}
                        data={PostageOptions}
                        defaultValues={props.defaultValues}
                        loading={postageLoading}
                        valueType={'number'}
                        reset={props.reset}
                        forwardValuesCallback={(e) => field.onChange(e)}
                    />
                }
            />
        </div>
    )
}

export default SendsPostageControl
